import starlinkKit from '../assets/starlink_kits.svg'
import routers from '../assets/routers_and_networking_gear.svg'
import accessories from '../assets/accessories.svg'
import cctv_blog from '../assets/cctv_blog.svg'
import network_blog from '../assets/network_blog.svg'
import consultancy_blog from '../assets/consultancy_blog.svg'


// Function to shuffle an array
export const shuffleArray = (array) => {
  let shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const shopFront = [
  {
    id: 1,
    title: 'Routers & networking gear',
    background: routers,
  },
  {
    id: 2,
    title: 'Starlink Kits',
    background: starlinkKit,
  },
  {
    id: 3,
    title: 'Cables, switches, and accessories',
    background: accessories,
  },
];

export const blogs = [
  {
    id: 1,
    title: 'Why every business needs professional network solutions',
    cover: network_blog,
  },
  {
    id: 2,
    title: 'The benefits of CCTV for home security',
    cover: cctv_blog,
  },
  {
    id: 3,
    title: 'How IT consultancy can save you money',
    cover: consultancy_blog,
  },
];

export const services = [
  {
    id: 1,
    service: 'Network solutions',
    description: 'Fast, secure, and scalable networking for every environment.',
    url: 'https://i.postimg.cc/mg50hNBq/network.jpg',
  },
  {
    id: 2,
    service: 'Software development',
    description: 'Modern, responsive websites tailored to your needs.',
    url: 'https://i.postimg.cc/RhWSJC2Q/web-development.jpg',
  },
  {
    id: 3,
    service: 'IT Consulting',
    description: 'Expert advice to optimise your technology investments.',
    url: 'https://i.postimg.cc/T2DhPp9t/it-consulting.jpg',
  },
  {
    id: 4,
    service: 'CCTV Installation',
    description: 'Advanced surveillance systems for peace of mind',
    url: 'https://i.postimg.cc/cLQzhySR/cctv-installation.jpg',
  },
  {
    id: 5,
    service: 'Fibre Optics Service',
    description:
      'Experience the future of connectivity with our fiber optics service. Enjoy lightning-fast, reliable internet with unparalleled speed and stability.',
    url: 'https://i.postimg.cc/4yvwYQds/fibre-optics.png',
  },
];

export const testimonials = [
  {
    id: 1,
    image: '',
    comment:
      'Yottanet upgraded our entire network—zero downtime and fantastic support!',
    customerName: 'Jane Doe',
    position: 'School Administrator',
  },
  {
    id: 2,
    image: '',
    comment:
      'The CCTV installation was quick, professional, and affordable. Highly recommended.',
    customerName: 'John Doe',
    position: 'Business Owner',
  },
  {
    id: 3,
    image: '',
    comment:
      'The website they designed for my company was awesome. Their communication and professionalism is topnotch.',
    customerName: 'Ben Doe',
    position: 'Entrepreneur',
  },
  {
    id: 4,
    image: '',
    comment:
      'Thanks to Yottanet Technologies, we are able now have access to low earth orbit satellite (starlink)',
    customerName: 'Fredrick Doe',
    position: 'Director MCC',
  },
  {
    id: 5,
    image: '',
    comment:
      'Their support for our IT infrastructure has been invaluable. Truly a reliable partner!',
    customerName: 'Sarah Connor',
    position: 'IT Manager',
  },
  {
    id: 6,
    image: '',
    comment:
      'Yottanet delivered a robust and scalable network solution that perfectly met our growing needs.',
    customerName: 'Michael Brown',
    position: 'Operations Director',
  },
];
